export default function AppSection() {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-200/50 overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-10 p-6 md:p-10">
              <div className="lg:w-[260px] shrink-0">
                <div className="relative w-48 h-48 md:w-56 md:h-56 mx-auto rounded-2xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20movie%20streaming%20app%20interface%20on%20dark%20screen%2C%20elegant%20cinema%20theme%20UI%2C%20warm%20golden%20and%20crimson%20accents%2C%20minimalist%20design%2C%20premium%20app%20showcase%2C%20clean%20dark%20background&width=512&height=512&seq=app-mobile&orientation=squarish"
                    alt="天堂影院移动端观影"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-100/70 via-transparent to-transparent"></div>
                </div>
              </div>

              <div className="flex-1 text-center lg:text-left">
                <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
                  移动观影
                </h2>
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-5">
                  天堂影院全面支持移动端访问，无需下载 APP，打开手机浏览器即可畅享高清影视在线观看。
                  响应式设计自动适配各种屏幕尺寸，无论是通勤路上还是睡前时光，随时随地开启您的私人影院。
                  支持手势控制播放进度、亮度与音量调节，让移动观影同样舒适便捷。
                </p>

                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#hero"
                    onClick={(e) => scrollTo(e, '#hero')}
                    className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-play-circle-line mr-1.5"></i>
                    立即体验
                  </a>
                  <span className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-500 text-sm font-medium cursor-pointer hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                    <i className="ri-qr-code-line mr-1.5"></i>
                    扫码访问
                  </span>
                </div>

                <div className="flex items-center justify-center lg:justify-start gap-4 mt-4">
                  <span className="flex items-center gap-1 text-xs text-foreground-300">
                    <i className="ri-android-line"></i>
                    Android
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-300">
                    <i className="ri-apple-line"></i>
                    iOS
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-300">
                    <i className="ri-windows-line"></i>
                    PC
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-300">
                    <i className="ri-tablet-line"></i>
                    Pad
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}